import { Api } from './Api';
import { OrderDTO, OrderItemDTO } from '../modules/orders/types';

export class OrdersApi {
  static async getOrders() {
    return await Api.get('/orders/api/v1/orders');
  }

  static async getOrder(id: string) {
    return await Api.get(`/orders/api/v1/orders/${id}`);
  }

  static async createOrder(order: OrderDTO) {
    const data = {
      status: order.status,
      number: order.number,
      created_at: order.created_at,
      order_items: order.order_items,
      user_id: order.user_id,
    };
    return await Api.post('/orders/api/v1/orders', data);
  }

  static async deleteOrder(id: string) {
    return await Api.delete(`/orders/api/v1/orders/${id}`);
  }

  static async commitOrder(id: string) {
    return await Api.post(`/orders/api/v1/orders/${id}/commit`);
  }

  static async addItems(id: string, items: OrderItemDTO[]) {
    return await Api.post(`/orders/api/v1/orders/${id}/add_items`, items);
  }

  static async getOrderItem(id: string) {
    return await Api.get(`/orders/api/v1/orders/items/${id}`);
  }

  static async updateOrderItem(id: string, item: OrderItemDTO) {
    return await Api.patch(`/orders/api/v1/orders/items/${id}`, item);
  }

  static async deleteOrderItem(id: string) {
    return await Api.delete(`/orders/api/v1/orders/items/${id}`);
  }
}
